import { useEffect, useState } from 'react';
import ComboBox from '../../components/controls/ComboBox/ComboBox';
import TextBox from '../../components/controls/TextBox/TextBox';
import classes from './role-transaction-limit-page.module.css';
import { AccountCacheService } from '../../services/accountService';
import roleService from '../../services/roleService';
import { IRoleTransactionLimit, UserTransactionLimit } from '../../models/interfaces';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TransactionLimit, { TransactionLimitData } from '../../components/controls/TransactionLimit/TransactionLimit';

export interface RoleTransactionLimitPageProps { }

type transactionLimitType = {
	transactionType?: string,
	period?: number,
	amount?: number
}

type periodLimit = {
	id: number,
	name: string
}

function getPeriodLimits(): periodLimit[] {
	return [
		{ id: 1, name: "Daily" },
		{ id: 2, name: "Weekly" },
		{ id: 3, name: "Monthly" }
	]
}

function RoleTransactionLimitPage(props: RoleTransactionLimitPageProps) {
	const [transactionLimits, setTransactionLimits] = useState<IRoleTransactionLimit[]>([])
	const [limit, setLimit] = useState<transactionLimitType>({});

	const accountCacheService = new AccountCacheService();

	const notValid = () => (limit.amount === 0 || limit.period === 0 || limit.transactionType === "");

	const [queryParams] = useSearchParams();

	const roleId = Number(queryParams.get("roleId"));
	if (roleId === 0) {
		//navigate("roles");
	}

	useEffect(() => {
		const getRoleLimits = async () => {
			var res = await roleService.getRoleTransactionLimits(Number(roleId));
			if (res.status) {
				setTransactionLimits(res.data as IRoleTransactionLimit[]);
			}
		}

		getRoleLimits();
	}, [roleId]);

	return (
		<div className='row'>
			<div className="col-6">
				<div className="row">
					<div className="col">
						<ComboBox id='transactionTypes' text='Transaction Types' prompt='Select Transaction Type(s)'
							items={accountCacheService.getTransationTypes().map(d => {
								const item = { id: d.id, name: d.name }
								return item;
							})}
							value={limit?.transactionType}
							onChange={(e) => {
								if (limit !== undefined) {
									setLimit({ ...limit, transactionType: e.currentTarget.value })
								}
								else {
									setLimit({ transactionType: e.currentTarget.value });
								}
							}} />
					</div>
					<div className="col">
						<ComboBox id='periodType' text='Period' prompt='Select Period'
							value={limit?.period}
							items={getPeriodLimits().map(d => { return { id: d.id, name: d.name } })}
							onChange={(e) => {
								if (limit !== undefined) {
									setLimit({ ...limit, period: Number(e.currentTarget.value) })
								}
								else {
									setLimit({ period: Number(e.currentTarget.value) });
								}
							}} />
					</div>
				</div>

				<TextBox id='amount' text='Amount' type='number' minValue={0}
					value={limit?.amount ?? 0}
					onChange={(e) => {
						if (limit !== undefined) {
							setLimit({ ...limit, amount: Number(e.currentTarget.value) })
						}
						else {
							setLimit({ amount: Number(e.currentTarget.value) });
						}
					}} />

				<hr />
				<div className="form-group">
					<button id='btnSaveTransactionLimit' className='btn btn-primary btn-sm'
						disabled={notValid()}
						onClick={() => {
							if (limit !== undefined) {
								const saveTransactionLimit = async () => {
									const res = await roleService.setRoleTransactionLimit(roleId, limit);
									console.log(res);
									if (res.status) {
										if (transactionLimits !== undefined) {
											const newList = [...transactionLimits, res.data as IRoleTransactionLimit];
											setTransactionLimits(newList);
										}
									}

									setLimit({
										amount: undefined,
										period: 1,
										transactionType: ""
									});
								}

								saveTransactionLimit();
							}
						}}>
						Add Limit
					</button>
				</div>

				<div style={{ marginTop: "20px" }}>
					<div className="table-responsive">
						<table className='table table-striped'>
							<thead>
								<th>Transaction Type</th>
								<th>Period</th>
								<th>Transaction Limit</th>
								<th>Action(s)</th>
							</thead>
							<tbody>
								{transactionLimits?.map(d => {
									return <tr key={`${d.transactionTypeCode}_${d.amount}_${d.roleId}_${d.roleId}`}>
										<td>{d.transactionTypeCode}</td>
										<td>{d.periodType}</td>
										<td>{d.amount}</td>
										<td>
											<button type='button' title='delete limit' className='btn-close' onClick={() => {
												const deleteRoleTransactionLimit = async () => {
													const ans = window.confirm('Are you sure you want to delete this limit');
													if (ans) {
														const res = await roleService.deleteRoleLimit({
															period: Number(d.periodType),
															roleId: Number(roleId),
															transactionType: d.transactionTypeCode
														});

														if (res.status) {
															const newLimits = transactionLimits.filter(limit => {
																return !(limit.periodType === d.periodType &&
																	limit.transactionTypeCode === d.transactionTypeCode &&
																	limit.roleId === Number(roleId))
															});

															setTransactionLimits(newLimits);
															alert('TransactionLimit deleted');
														}
													}
												}

												deleteRoleTransactionLimit();

											}}></button>
										</td>
									</tr>
								})}
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div className="col-6"></div>
		</div>
	);
}

export default RoleTransactionLimitPage;